(function() {
    AOS.init();
})();

//# sourceMappingURL=index.5d831e40.js.map
